import { ToEntity } from 'core/common/mappers';
import { UserAskNebula } from 'core/user/entities';
import { UserAskNebulaDto } from 'core/user/services/dto';

export class UserAskNebulaDtoMapper implements ToEntity<UserAskNebula, UserAskNebulaDto> {
  toEntity(dto: UserAskNebulaDto): UserAskNebula {
    return {
      accountId: dto.account_id,
      authenticationToken: dto.authentication_token,
    };
  }
}
